import { render, staticRenderFns } from "./insureList.vue?vue&type=template&id=2609b008&scoped=true&"
import script from "./insureList.vue?vue&type=script&lang=js&"
export * from "./insureList.vue?vue&type=script&lang=js&"
import style0 from "./insureList.vue?vue&type=style&index=0&id=2609b008&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2609b008",
  null
  
)

export default component.exports